import { Elements, RecurlyProvider} from '@recurly/react-recurly';
import { observer } from 'mobx-react-lite';
import { TestOneTimePaymentForm } from './TestOneTimePaymentForm';

export const TestOneTimePayments = observer(() => {
  return (
    <div className='go-premium-wrapper'>
      <RecurlyProvider publicKey={process.env.REACT_APP_RECURLY_PUBLIC_KEY}>
        <Elements>
          <TestOneTimePaymentForm />
        </Elements>
      </RecurlyProvider>
    </div>
  )
});


